export { FieldError as default } from "./styled";
